module.exports = __webpack_public_path__ + "static/media/strikethrough.746e5cf4.svg";